module.exports = __webpack_public_path__ + "static/v-cup-size-guide-fefb54d8066f606378acb837b4e09fe0.webp";